import { RateTypes } from './rate-types';

export const RATE_TYPE_LABEL_MAP: Record<RateTypes, string> = {
  [RateTypes.GrnPerLiter]: 'грн/л',
  [RateTypes.Percent]: '%',
};
